import type { FieldPath, FieldValues } from "react-hook-form"
import { useFormContext } from "react-hook-form"
import getOwnMessage from "./getOwnMessage"

const ancestorPaths = (fieldName: string): string[] => {
  const segments = fieldName.split(".")

  return segments.slice(0, -1).map((_, i) => segments.slice(0, i + 1).join("."))
}

export default <TValues extends FieldValues>(fieldName: FieldPath<TValues>) => {
  const {
    control,
    formState: { errors },
  } = useFormContext<TValues>()

  const formError = errors.root?.formError?.message
  const error = getOwnMessage(errors, fieldName)
  const hasAncestorError = ancestorPaths(fieldName).some(
    (p) => !!getOwnMessage(errors, p),
  )

  return {
    control,
    isError: !!error || hasAncestorError || !!formError,
    error,
  }
}
